import React, {ReactNode} from "react";
import {Theme} from '@mui/material/styles';
import {Button, useTheme} from "@mui/material";
import {SxProps} from "@mui/system";

export function AlertButton(props: {
  onClick: () => void,
  title?: string,
  sx?: SxProps<Theme>,
  children?: ReactNode
}) {
  const theme = useTheme();

  return (
    <Button size={'medium'}
            sx={{
              ...props.sx,
              background: theme.palette.error.main,
              color: theme.palette.background.default,
              minWidth: 150,
              paddingLeft: theme.spacing(2),
              paddingRight: theme.spacing(2),
              borderRadius: '1',
              '&:hover': {
                background: theme.palette.error.light,
              }
            }}
            onClick={props.onClick}>
      {props.children}
      {props.title}
    </Button>
  );
}
